{
  "version": 1,
  "asset_id": "c37c161b-e9a0-475c-916a-c65840c5b9c0",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/c37c161b-e9a0-475c-916a-c65840c5b9c0/lighting-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/c37c161b-e9a0-475c-916a-c65840c5b9c0/lighting-thumb.webp",
  "original_filename": "lighting-thumb.webp",
  "size": 3118,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:53Z"
}
